import React from 'react';
import {Link} from 'react-router-dom';
import MetaTags from "../components/MetaTags";

const Articles: React.FC = () => {

    MetaTags(
        "Статьи о бисероплетении",
        "Статьи о бисероплетении - схемы изготовления украшений, уроки по различным техникам плетения из бисера, цепочки из бисера."
    )

    return <>
        <h2>Статьи о бисероплетении</h2>
        <ul className="articles">
            <li><Link to="/kvadrat-stolbik">Квадратный столбик</Link></li>
            <li><Link to="/solnishko">Кулон «Солнышко»</Link></li>
            <li><Link to="/podstavka">Подставка под чашку</Link></li>
            <li><Link to="/vetochka">Веточка из бисера</Link></li>
            <li><Link to="/krestik">Плетение крестиком</Link></li>
            <li><Link to="/history">История бисероплетения</Link></li>
            <li><Link to="/shnur">Шнур из бисера</Link></li>
            <li><Link to="/vosmerka">Сетчатое плетение</Link></li>
            <li><Link to="/opletenie-bousin">Оплетение бусин</Link></li>
            <li><Link to="/circle-brelok">Круглый брелок</Link></li>
        </ul>
    </>
        ;
};

export default Articles;

